//@ts-nocheck
import {
  GridRenderCellParams,
  useGridApiContext,
  useGridSelector,
  gridFilteredDescendantCountLookupSelector,
} from '@mui/x-data-grid-pro';
import { Box } from '@mui/material';
import { RichTextReadOnly } from 'mui-tiptap';

import useExtensions from 'pages/SystemTenant/RowenaAI/RowenaDefinition/components/useExtensions';
import { useHoverPopper } from './HopperPopperAttributeProvider';

interface CustomGridTreeDataGroupingCellProps extends GridRenderCellParams {
  cellDescription?: Record<string, string>;
}

export function CustomGridTreeDataGroupingCell(props: CustomGridTreeDataGroupingCellProps) {
  const { rowNode, cellDescription } = props;
  const apiRef = useGridApiContext();
  const filteredDescendantCountLookup = useGridSelector(apiRef, gridFilteredDescendantCountLookupSelector);
  const filteredDescendantCount = filteredDescendantCountLookup[rowNode.id] ?? 0;

  const extensions = useExtensions({ placeholder: 'Add your own content here...' });

  const { scheduleShow, hide } = useHoverPopper();

  const text = cellDescription?.[rowNode.groupingKey];

  const handleEnter = (e: React.MouseEvent<HTMLElement>) => {
    if (!text) return;
    const anchor = e.currentTarget as HTMLElement;
    scheduleShow({
      anchor,
      delayMs: 300,
      placement: 'right',
      content: (
        <RichTextReadOnly
          content={text}
          extensions={extensions}
          sx={{
            '& p': { margin: 0, fontSize: '13px' },
          }}
        />
      ),
    });
  };

  const handleLeave = () => hide();

  return (
    <Box sx={{ ml: rowNode.depth * 1.2 }}>
      <Box
        component='span'
        sx={{
          position: 'relative',
          display: 'inline-block',
          fontWeight: filteredDescendantCount > 0 ? 'bold' : undefined,
          cursor: 'pointer',
          px: 1,
          py: 0.5,
          mx: -0.75,
          my: -0.5,
          borderRadius: 0.75,
          '&:hover': { bgcolor: 'action.hover' },
        }}
        onMouseEnter={handleEnter}
        onMouseLeave={handleLeave}
      >
        {rowNode.groupingKey}
      </Box>
    </Box>
  );
}
